module.exports = __webpack_public_path__ + "img/dku.02938.f24b29cd.png";